import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLockedTime, setModalOpen, setModalType, setReload } from 'store/ResponseTemplate/actions';
import { useTheme } from '@mui/material/styles';
import { Button, IconButton, Box, FormControl, InputLabel, Grid } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useMutation } from '@apollo/client';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import FormFields from 'Components/FormFields';
import RemoveConfirmationModal from './RemoveConfirmation';
import { UPDATE_LOCK_QUESTION_REGISTRY_DETAIL, UPDATE_QUESTION_REGISTRY } from 'schemas/mutation';
import { setSelectedItem } from 'store/Calendar/actions';
const ViewQuestionRegistries = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { selectedItem, reload } = useSelector((params) => params.response);
    const { companyData } = useSelector((params) => params.customization);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [deleteMutation] = useMutation(UPDATE_QUESTION_REGISTRY);
    const [updateLockedTime] = useMutation(UPDATE_LOCK_QUESTION_REGISTRY_DETAIL);
    const handleSoftDelete = async () => {
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
        let variables = {
            editQuestionRegistryInput: {
                companyId: companyData._id,
                status: 'deleted',
                questionRegistryIds: [selectedItem._id]
            }
        };
        try {
            await deleteMutation({ variables: { ...variables } });
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'success',
                    message: 'Question sent to Deleted tab.'
                }
            });
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: setReload, reload: !reload });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: 'Something went wrong while trying to delete the question registry. Please try again later'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({ type: setSelectedItem, selectedItem: null });
        }
    };
    const handleCloseConfirmation = async (type) => {
        if (type === 'Y') {
            await handleSoftDelete();
            setIsConfirmationModalOpen(false);
        } else {
            setIsConfirmationModalOpen(false);
        }
    };
    const handleEditClicked = async () => {
        try {
            dispatch({ type: SET_LOADING, loading: true });
            dispatch({
                type: setLockedTime,
                lockedTime: null
            });
            dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
            let variables = {
                updateQuestionRegistryLockedTime: {
                    companyId: companyData._id,
                    type: 'add',
                    registryId: selectedItem._id
                }
            };
            const response = await updateLockedTime({
                variables: {
                    ...variables
                }
            });
            dispatch({
                type: setLockedTime,
                lockedTime: response.data.updateQuestionRegistryLockedTime
            });
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: setModalOpen, modalOpen: true });
            dispatch({ type: setModalType, modalType: 'edit' });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'warning',
                    message: 'Someone is already drafting this question.'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };
    return (
        <>
            <Box className="modal-header">
                <h3>View question</h3>
                <IconButton
                    onClick={() => {
                        dispatch({ type: setModalOpen, modalOpen: false });
                    }}
                    className="modal-close"
                >
                    <CloseOutlinedIcon className="icon-yellow-fill" />
                </IconButton>
            </Box>
            <Box className="modal-body">
                <Formik
                    initialValues={{
                        question: selectedItem.question,
                        response: selectedItem.response
                    }}
                >
                    {({ handleBlur, handleChange, values }) => (
                        <Form>
                            <Grid container rowSpacing={1.5}>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }}>
                                        <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel>
                                        <FormFields
                                            type="outlined-input"
                                            name="question"
                                            label="Question"
                                            value={values.question}
                                            id="outlined-adornment-title"
                                            readOnly={true}
                                            disabled={true}
                                            inputprops={{}}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }} className="contact-textarea-formcontrol">
                                        <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel>
                                        <FormFields
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.response}
                                            name="response"
                                            disabled={true}
                                            readOnly={true}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box className="modal-footer-2">
                                        <Button
                                            type="button"
                                            className="alternate-reversed"
                                            onClick={() => {
                                                setIsConfirmationModalOpen(true);
                                            }}
                                        >
                                            Remove
                                        </Button>
                                        <Button type="button" className="alternate" onClick={handleEditClicked}>
                                            Edit
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
                {isConfirmationModalOpen && <RemoveConfirmationModal parentModalClose={handleCloseConfirmation} />}
            </Box>
        </>
    );
};

export default ViewQuestionRegistries;
